import { Outlet } from 'react-router-dom';
import ErrorBanner from '../components/shared/ErrorBanner.jsx';

// Slot for app-wide chrome that should appear on every route (including login).
// Right now: just the global error banner + the router outlet.
export default function RootLayout() {
  return (
    <>
      <ErrorBanner />
      <Outlet />
    </>
  );
}
